// import { baseUrl, headers, jwtHeaders, logoutUtil } from "../common/data";
import { baseUrl, jwtHeaders, logoutUtil } from "../common/data";

export const fetchAllBranch = async ({ limit, page }) => {
    const response = await fetch(`${baseUrl}/api/branch/getallbranch`, {
        method: "GET",
        headers: jwtHeaders(),
        redirect: "follow",
    });

    if (response?.status === 401) {
        logoutUtil();
    }
    const resData = await response?.json();
    // console.log('all branch data=================================================>', resData);
    return resData;
};

export const createBranch = async (data) => {

        const response = await fetch(`${baseUrl}/api/branch/create`, {
            method: 'POST',
            body: data,
            // headers: headers
            headers:jwtHeaders(),
        })
        const resData = await response?.json();
        // console.log('client add data=================================================>', resData);
        return resData;

};

export const deleteBranch = async (data) => {

        const response = await fetch(`${baseUrl}/api/branch/deletebranch/${data}`, {
            method: 'DELETE',
            // headers: headers,
            headers:jwtHeaders(),
        })
        const resData = await response?.json();
        // console.log('branch delete data=================================================>', resData);
        return resData;
    
};